import React from "react";
import { Modal, Button, Flex } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const CustomDeleteModal = ({
  visible,
  onClose,
  onConfirm,
  title,
  message,
  cancelText,
  confirmText,
  confirmColor,
  width = 542, 
  height = 184
}) => {
  return (
    
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={width}
      style={{ minHeight: height , borderRadius:'16px' }} 
      className="custom-delete-modal"
    >
      <Flex
        justify="space-between"
        align="center"
        style={{ marginBottom: "12px" }}
      >
        <h3 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
          {title}
        </h3>
        <CloseOutlined
          style={{ fontSize: "16px", cursor: "pointer" }}
          onClick={onClose}
        />
      </Flex>

      <p style={{ fontSize: "14px", color: "#000", marginBottom: "20px" }}>
        {message}
      </p>
      <Flex justify="end" gap={12}>
        {cancelText && (
          <Button
            type="text"
            onClick={onClose}
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#000",
              height:'40px',
            }}
          >
            {cancelText}
          </Button>
        )}

        {confirmText && (
          <Button
            type="primary"
            danger
            onClick={onConfirm}
            style={{
              height:'40px',
              backgroundColor: confirmColor,
              borderColor: confirmColor,
              fontSize: "14px",
              fontWeight: "600",
              padding: "10px 12px",
              borderRadius: "8px",
            }}
          >
            {confirmText}
          </Button>
        )}
      </Flex>
    </Modal>
);
};

export default CustomDeleteModal;
